export enum LineMessageLogQueryKey {
	GetLineMessageLogs = 'GetLineMessageLogs',
	GetLineMessageLogMessages = 'GetLineMessageLogMessages',
	GetLineMessageLogGrouped = 'GetLineMessageLogGrouped',
}

export const LOG_TYPE_OPTIONS = [
	{ label: 'ทั้งหมด', value: '' },
	{ label: 'Broadcast', value: 'BROADCAST' },
	{ label: 'Auto Reply', value: 'AUTO_REPLY' },
	{ label: 'Greeting', value: 'GREETING' },
]

export const LOG_TYPE_LABELS: Record<string, string> = {
	BROADCAST: 'Broadcast',
	AUTO_REPLY: 'Auto Reply',
	GREETING: 'Greeting',
}
